module.exports = __webpack_public_path__ + "img/star.697b8e48.svg";